export default {"src":"/_next/static/media/mapbox-marker.866c1bd3.svg","height":60,"width":54,"blurWidth":0,"blurHeight":0};